<template>
  <div style="">

    <div style="width:100%;height:200px;background:url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/myBg.png') center center/cover no-repeat">

      <div style="color:#fff;text-align:center;height:40px;line-height:40px;font-size:16px;">
        <van-icon name="shop-o"  style="margin-right:10px;" />{{ name }}
      </div>

      <div style="margin-top:10px;font-size:20px;color:#fff;padding:0 20px;">
        <div style="text-align:center;">

          <van-field v-model="form.code" placeholder="请输入核销码" :rules="[{ required: true, message: '请输入手机号' }]">

            <template #button>
              <van-button size="small" type="primary" @click="checkCouponBtn">确定</van-button>
            </template>

          </van-field>

          <div>
            <van-button size="small" type="primary" @click="scan">扫一扫</van-button>

          </div>
          <div style="margin-top:10px;color:#fff;font-size:14px;">
            * 每次请输入或者扫一扫一个有效核销码
          </div>
        </div>
      </div>

      <div style="text-align:left">

        <van-cell-group inset>
           <van-cell :title="item.couponName" :value="item.date" :label="item.operator"  v-for="(item, index) in memberList" :key="index"/>
        </van-cell-group>

      </div>

    </div>
  </div>
</template>

<style>
.van-field__body {
  width: 70vw;
}
</style>
<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
  li {
    line-height: 25px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
<script>
const columns = [
  {
    title: '优惠券名称',
    dataIndex: 'couponName',
    key: 'couponName',
    ellipsis: true,
  },
  {
    title: '日期',
    dataIndex: 'date',
    key: 'date',
    ellipsis: true,
    width: '160px',
  },
  {
    title: '操作人',
    dataIndex: 'orderSn',
    key: 'orderSn',
    ellipsis: true,
  },
]

import { getConfig, checkCoupon, getCheckList } from '@/api/mehzShop'
import { getQueryStringBySearch } from '@/utils/utils'
export default {
  computed: {},
  mounted() {
    if (getQueryStringBySearch(location.search, 'access_token')) {
      this.token = getQueryStringBySearch(location.search, 'access_token')
      let name = getQueryStringBySearch(location.search, 'shopName')
      localStorage.setItem('access_token', this.token)
      localStorage.setItem('shopName', decodeURIComponent(decodeURIComponent(name)))
      this.name = decodeURIComponent(decodeURIComponent(name))
    } else {
      this.name = decodeURIComponent(decodeURIComponent(localStorage.getItem('shopName')))
    }

    this.getConfigData()
    this.getList()
  },
  methods: {
    async getConfigData() {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        token: this.token,
      }
      let { data } = await getConfig(headers, encodeURIComponent(location.href.split('#')[0]))
      window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ['scanQRCode'], // 必填，需要使用的JS接口列表
      })
    },

    getList() {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        token: this.token,
      }
      getCheckList(headers).then((res) => {
        console.log(res)
        this.memberList = res.data.list
      })
    },

    scan() {
      var _this = this
      wx.ready(function () {
         wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            console.log(res)
            var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            _this.form.code = result
          },
        })
      })
    },

    checkCouponBtn() {
      if (this.form.code) {
        var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
        let headers = {
          'x-call-client-info': JSON.stringify(headerClientInfo),
          token: this.token,
        }
        checkCoupon(headers, this.form.code)
          .then((res) => {
            console.log(res)
            this.$toast.success('核销完成')
            this.form.code = ''
            this.getList()
          })
          .catch((err) => {
            this.$toast.warning('核销失败')
          })
      } else {
        this.$toast.warning('核销码不正确')
      }
    },
  },
  data() {
    return {
      columns,
      name: '',
      memberList: [],
      token: '',
      form: {
        code: '',
      },
    }
  },
}
</script>

<style scoped>
.ant-page-header-heading {
  color: #fff;
}
</style>